import { IpfError } from '@ipfabric/frontend-shared-assets/utils/IpfError';
import type { BaseTexture, Texture } from 'pixi.js';
import { isTextureLoaded } from 'utils/pixi/isTextureLoaded';

export const waitForTextureLoad = (texture: Texture): Promise<void> =>
  new Promise((resolve, reject) => {
    if (isTextureLoaded(texture)) {
      resolve();
    } else {
      texture.baseTexture.on('loaded', () => {
        resolve();
      });
      texture.baseTexture.on('error', (t: BaseTexture, errorEvent: Event) => {
        reject(
          new IpfError('PIXI_TEXTURE_LOAD', 'failed to load texture', {
            texture: t,
            errorEvent,
          }),
        );
      });
    }
  });
